import styles from "./style.module.css";

const AuthInput = ({ name, className, register, ...props }) => {
  return <input className={[styles.authinput, className].join(" ")} name={name} {...register(name)} {...props} />;
};

export default AuthInput;
